import Chart from "react-apexcharts";
import { useEffect, useState } from "react";
import { toastEmitter } from "../../../../utills/utilities";
import { API_RESPONSE } from "../../../../utills/app-constant";
import { dimensionFuture } from "../../../../services/api-services";
import generateChartImage from "../generateChartImage";
import Remark from "../Remark";
import DownloadGraphButton from "../../../../user/pages/page/DownloadGraphButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DimenstionFutureChart = ({ selectedCompanyId, graphName, myhandleExport }) => {
  const [responseBody, setResponseBody] = useState([]);
  const [loading, setLoading] = useState(false);
  const [remark, setRemark] = useState("");
  const [remarkId, setRemarkId] = useState(null);
  const [isAttempt, setIsAttempt] = useState("");

  useEffect(() => {
    const getDimenstionFutureData = async () => {
      setLoading(true);
      try {
        const response = await dimensionFuture(selectedCompanyId, graphName);
        if (response?.data?.responseCode === 200) {
          setResponseBody(response?.data?.responseBody || []);
          setRemark(response?.data?.remark || "");
          setRemarkId(response?.data?.remarkId || null);
          setIsAttempt(response?.data?.isAttempt ?? 0);
        } else {
          setResponseBody([]);
          toastEmitter("error", response?.data?.message || "No data found");
        }
      } catch (err) {
        toastEmitter("error", API_RESPONSE.MESSAGE_503);
      } finally {
        setLoading(false);
      }
    };

    if (selectedCompanyId) getDimenstionFutureData();
  }, [selectedCompanyId, graphName]);

  const generateChartData = (subdimension) => {
    const questionResponseList = subdimension?.questionResponseList || [];
    if (!questionResponseList.length) return { options: {}, series: [] };

    const criteriaLabels = questionResponseList.map((item) => item?.criteriaShortLabel || "No Data");
    const markerColors = ["#D42327", "#fd8000", "#ffbf01", "#dbc51a", "#92d14e"];

    const seriesData = ["Initiating", "Emerging", "Performing", "Advancing", "Leading"].map((name, index) => ({
      name,
      data: questionResponseList.map((item) => item?.[`${name.toLowerCase()}Value`] ?? 0),
    }));

    return {
      options: {
        chart: {
          id: `customer_dimension_future_${subdimension.subDimensionName.replace(/\s+/g, "_")}`,
          type: "bar",
          stacked: true,
          stackType: "100%",
          events: {
            mounted: () => {
              setTimeout(() => {
                generateChartImage(
                  `customer_dimension_future_${subdimension.subDimensionName.replace(/\s+/g, "_")}`,
                  "customer_dimension_future",
                  remark
                );
              }, 500);
            },
          },
        },
        plotOptions: {
          bar: { horizontal: true, barHeight: "35%" },
        },
        dataLabels: {
          enabled: true,
          style: { colors: ["#000"], fontSize: "9px" },
        },
        xaxis: { categories: criteriaLabels },
        fill: { opacity: 1, colors: markerColors },
        legend: { position: "top", offsetX: 100, markers: { fillColors: markerColors } },
      },
      series: seriesData,
    };
  };

  const exportToExcel = (data, fileName = "Dimension - Current") => {
    if (!data || !Array.isArray(data)) return;

    const heading = ["Dimension - Current"];
    const headers = [
      "Subdimension Name",
      "Initiating Value",
      "Emerging Value",
      "Performing Value",
      "Advancing Value",
      "Leading Value"
    ];

    const rows = [];

    data.forEach(dimension => {
      dimension?.dimensionResponseList?.forEach(sub => {
        let initiating = 0, emerging = 0, performing = 0, advancing = 0, leading = 0;

        sub?.questionResponseList?.forEach(question => {
          initiating += question.initiatingValue || 0;
          emerging += question.emergingValue || 0;
          performing += question.performingValue || 0;
          advancing += question.advancingValue || 0;
          leading += question.leadingValue || 0;
        });

        rows.push([
          sub.subDimensionName || "",
          initiating.toFixed(2),
          emerging.toFixed(2),
          performing.toFixed(2),
          advancing.toFixed(2),
          leading.toFixed(2)
        ]);
      });
    });

    const worksheet = XLSX.utils.aoa_to_sheet([
      heading,
      [],
      headers,
      ...rows
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subdimension Summary");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, fileName);
  };

  return (
    <div className="stackedChart_content">
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : responseBody.length ? (
        responseBody.map((dimension, dimensionIndex) =>
          dimension.dimensionResponseList.map((subdimension, subIndex) => {
            if (!subdimension?.questionResponseList?.length) {
              return <p key={`${dimensionIndex}-${subIndex}`}>No data available for {subdimension?.subDimensionName}</p>;
            }
            const { options, series } = generateChartData(subdimension);
            return (
              <div key={`${dimensionIndex}-${subIndex}`} className="chart-container">
                <div className="d-flex justify-content-between">
                  <h5>{subdimension?.subDimensionName}</h5>

                  <div className="d-flex">
                    <DownloadGraphButton chartID={`chart20-${subdimension?.id}`} myhandleExport={myhandleExport} />
                    <button className="px-3 py-2 mb-3 text-white bg-primary rounded border-0 ms-2" onClick={() => exportToExcel(responseBody)}>Download Excel</button>
                  </div>

                </div>
                <div className={`chart20-${subdimension.id}`} data-heading={subdimension?.subDimensionName} data-remark={remark}>
                  <Chart options={options} series={series} type="bar" height={250} />
                </div>
              </div>
            );
          })
        )
      ) : (
        <p>No data available</p>
      )}
      <Remark selectedCompanyId={selectedCompanyId} graphName="CustomerDimensionFuture" initialRemark={remark} remarkId={remarkId} isAttempt={isAttempt} setRemarkprops={setRemark} />
    </div>
  );
};

export default DimenstionFutureChart;
